import {
  required,
  maxLength,
  addressLine,
  postcode,
  usZipCode,
  frPostcode,
  iePostcode,
  otherPostcode,
  townRegionLine,
} from 'utils/validation';

const requiredPostCode = 'Please enter your postcode';

const line1Validator = {
  required: 'Please enter the first line of your address',
  validate: { maxLength: maxLength(60), pattern: addressLine },
};
const line2Validator = { validate: { maxLength: maxLength(50), pattern: addressLine } };
const line3Validator = { validate: { maxLength: maxLength(50), pattern: addressLine } };
const townValidator = { validate: { maxLength: maxLength(35), pattern: townRegionLine } };
const regionValidator = { validate: { maxLength: maxLength(75), pattern: townRegionLine } };
const zipCodeValidator = {
  required: requiredPostCode,
  validate: { maxLength: maxLength(10), pattern: otherPostcode },
};
const ukPostcodeValidator = {
  required: requiredPostCode,
  validate: { maxLength: maxLength(10), pattern: postcode },
};
const usZipCodeValidator = {
  required: requiredPostCode,
  validate: { maxLength: maxLength(10), pattern: usZipCode },
};
const frPostcodeValidator = {
  required: requiredPostCode,
  validate: { maxLength: maxLength(10), pattern: frPostcode },
};
const iePostcodeValidator = {
  required: requiredPostCode,
  validate: { maxLength: maxLength(10), pattern: iePostcode },
};
const countryValidator = [required];

export {
  countryValidator,
  frPostcodeValidator,
  iePostcodeValidator,
  line1Validator,
  line2Validator,
  line3Validator,
  regionValidator,
  townValidator,
  ukPostcodeValidator,
  usZipCodeValidator,
  zipCodeValidator,
};
